// Components
import { DatepickerGlobal } from '@/components/layouts/LayoutPlatform/components/Header/components/DatepickerGlobal';
import { ManageProfiles } from '@/components/layouts/LayoutPlatform/components/Header/components/ManageProfiles/Popover';

export function DefaultLeftSide() {
    return (
        <div className="flex items-center gap-1 xs:gap-3">
            <ManageProfiles />
            <DatepickerGlobal />
        </div>
    );
}
